import { IClassroomsEnrollmentsData } from 'services/graduate-enrollment/evaluations';
import { ReactNode, useMemo } from 'react';
import { Tag, Typography } from 'antd';
import { getDisciplineStatusDisplay } from 'services/graduate-enrollment/discipline-status';

interface ClasssroomEnrollmentHeaderProps {
  classroomEnrollment: IClassroomsEnrollmentsData;
}

const MetricField = ({ label, value }: { label: string; value: ReactNode }) => (
  <div className="flex min-w-0 flex-col">
    <Typography.Text type="secondary" className="text-xs leading-none">
      {label}
    </Typography.Text>
    <Typography.Text className="mt-1 text-sm text-neutral-800">
      {value}
    </Typography.Text>
  </div>
);

export const ClasssroomEnrollmentHeader = ({
  classroomEnrollment
}: ClasssroomEnrollmentHeaderProps) => {
  const status = useMemo(
    () => getDisciplineStatusDisplay(classroomEnrollment),
    [classroomEnrollment]
  );

  const attendanceRate =
    classroomEnrollment.academic_record_attendance_rate != null
      ? `${classroomEnrollment.academic_record_attendance_rate}%`
      : classroomEnrollment.attendance_rate != null
      ? `${classroomEnrollment.attendance_rate}%`
      : '-';
  const score = classroomEnrollment.academic_record_score ?? '-';
  const progressPercentage =
    classroomEnrollment.progress_percentage != null
      ? `${classroomEnrollment.progress_percentage}%`
      : '-';

  return (
    <div className="flex w-full items-center justify-between gap-6">
      <div className="min-w-0 flex-1">
        <Typography.Text strong className="block truncate text-neutral-800">
          {classroomEnrollment.classroom.discipline.name}
        </Typography.Text>
        <Typography.Text type="secondary" className="block text-sm">
          Turma: {classroomEnrollment.classroom.code}
        </Typography.Text>
      </div>

      <div className="grid shrink-0 grid-cols-[4.5rem_4.5rem_3.25rem_11rem] items-center gap-x-8">
        <MetricField label="Frequência" value={attendanceRate} />
        <MetricField label="Progresso" value={progressPercentage} />
        <MetricField label="Nota" value={score} />
        <div className="flex items-center">
          <Tag color={status.color} className="m-0 whitespace-nowrap">
            {status.label}
          </Tag>
        </div>
      </div>
    </div>
  );
};
